import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAppConfigStore } from '@/stores/app-config-store'

export const useDynamicFavicon = () => {
  const route = useRoute()
  const appConfigStore = useAppConfigStore()

  const updateFavicon = () => {
    // Extract client segment from URL.
    // For /auth/* routes we also support a stored client segment so pre-login branding can work.
    const pathSegments = route.path.split('/')
    const isAuthRoute = pathSegments[1] === 'auth'
    const storedClientSegment = isAuthRoute ? sessionStorage.getItem('clientSegment') : null
    const clientSegment = (isAuthRoute ? storedClientSegment : pathSegments[1]) || '' // First segment after domain

    let shouldUseClientLogo = false
    let faviconUrl = ''

    if (clientSegment && appConfigStore.CLIENT_URL_SEGMENT_CLIENT_DATA_MAP[clientSegment]) {
      const clientData = appConfigStore.CLIENT_URL_SEGMENT_CLIENT_DATA_MAP[clientSegment]

      if (clientData.faviconUrl) {
        shouldUseClientLogo = true
        faviconUrl = clientData.faviconUrl
      }
    }

    // Remove existing favicon links
    const existingFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]')
    existingFavicons.forEach((favicon) => favicon.remove())

    // Create new favicon link
    const faviconLink = document.createElement('link')
    faviconLink.rel = 'icon'
    faviconLink.type = 'image/x-icon'

    if (shouldUseClientLogo) {
      faviconLink.href = faviconUrl
      console.log('Setting client favicon:', faviconUrl)
    } else {
      faviconLink.href = '/favicon.ico'
      console.log('Setting default favicon')
    }

    // Add to document head
    document.head.appendChild(faviconLink)
  }

  // Watch for route changes
  watch(() => route.path, updateFavicon, { immediate: true })

  // Watch for app config changes (when logo is updated)
  watch(() => appConfigStore.CLIENT_URL_SEGMENT_CLIENT_DATA_MAP, updateFavicon, { deep: true })

  return {
    updateFavicon,
  }
}
